import { render } from "./SccAndIsy.vue?vue&type=template&id=65755cbd&ts=true"
import script from "./SccAndIsy.vue?vue&type=script&lang=ts"
export * from "./SccAndIsy.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__